import { Dispatch, SetStateAction } from 'react';
import X from 'icons/X';

export type Tag = { name: string; value: string | number; color?: string };

type BadgeProps = {
  arr: Tag[];
  tag: Tag;
  set: Dispatch<SetStateAction<Tag[]>>;
};

const Badge: React.FC<BadgeProps> = ({ arr, tag, set }) => {
  const handleSelectTag = (arr: Tag[], tag: Tag): Tag[] => {
    if (arr.some((v) => v.value === tag.value)) return arr.filter((v) => v.value !== tag.value);
    else return [...arr, tag];
  };

  return (
    <li key={tag.value} className={'my-2 mr-3'}>
      <button
        className={`flex flex-nowrap items-center rounded-full px-5 py-3 leading-none ring-1 ${
          arr.some((v) => v.value === tag.value) ? 'text-white ring-white' : 'text-black ring-black'
        }`}
        style={{ backgroundColor: arr.some((v) => v.value === tag.value) ? tag.color : '' }}
        onClick={() => set([...handleSelectTag(arr, tag)])}>
        {tag.name}
        {arr.some((v) => v.value === tag.value) ? (
          <span className="ml-2 mt-[2px]">
            <X size="1.1rem" />
          </span>
        ) : null}
      </button>
    </li>
  );
};

export default Badge;
